import type { IconProps } from './types';

function PlusIcon(props: IconProps) {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M12 2V22M2 12H22" stroke={color} strokeWidth="1.5" />
    </svg>
  );
}

export { PlusIcon };
